import React, { ReactNode } from "react";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Modal } from "@tvg/design-system";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { QA_LABELS } from "../../utils/constants";

export interface Props {
  title?: string;
  subtitle?: string;
  isOpen: boolean;
  children: ReactNode;
  onClose: NullaryFn<void>;
  onBack?: NullaryFn<void>;
  onOverlayClick?: NullaryFn<void>;
}

const SplashScreen = ({
  isOpen,
  title,
  subtitle,
  children,
  onClose,
  onBack,
  onOverlayClick
}: Props) => (
  <SafeAreaProvider>
    <Modal
      isOpen={isOpen}
      title={title || ""}
      qaLabel={QA_LABELS.BASE_MODAL}
      paddingX={48}
      paddingBottom={36}
      paddingTop={16}
      maxWidth="960px"
      subtitle={subtitle}
      onClose={onClose}
      onOverlayClick={onOverlayClick}
      hasBorderBottom={false}
      onBack={onBack}
    >
      <>{children}</>
    </Modal>
  </SafeAreaProvider>
);

export default SplashScreen;
